<ng-container *ngIf="feature">
    <div [innerHTML]="feature.text | trustHtml"></div>
</ng-container>